<p-dialog header="ふれあい体験希望詳細" [(visible)]="boardFlag" [modal]="true" [responsive]="true" [styleClass]="'main-dialog'"
  (onHide)="closeDialog()">
  <div class="main-height">
    <!-- メイン -->

    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="p-fluid p-formgrid p-grid screen-support">
        <div class="p-col-12">
          <div class="p-fluid p-formgrid p-grid support-header">
            <div class="p-col-12">
              <p-card class="support-header-card">
                <div class="support-header-card-show">
                  <div class="p-fluid p-formgrid p-grid support-header-card-detail">
                    <div class="p-col-4 image">
                      <div class="support-header-card-detail-img" [ngStyle]="{
                          'background-image':
                            'url(' + detailTask?.icon_image + ')'
                        }"></div>
                    </div>
                    <div class="p-col-8 support-desc">
                      <div class="support-description-detail">
                        <span class="support-tag-category" [ngClass]="setClassSubId()">{{
                          detailTask?.class_sub_id }}</span>
                        <span class="support-large-title primary-title p-text-bold"
                          [pTooltip]="detailTask?.municipalities + ' ' + detailTask?.organization_name"
                          #organization_name [tooltipDisabled]="!isOverflow(organization_name)">{{
                          detailTask?.municipalities + ' ' + detailTask?.organization_name
                          }}</span>
                        <!-- Change location -->
                        <div class="support-sub-title" [pTooltip]="detailTask?.oneword_message" #oneword_message
                          [tooltipDisabled]="!isOverflow(oneword_message)">
                          <span>{{ detailTask?.oneword_message }}</span>
                        </div>
                      </div>
                      <!-- <div class="support-btn" *ngIf="detailTask?.isOwner === 1">
                        <ng-container>
                          <div class="p-col-12">
                            <div class="func-with-owner">
                              <div class="p-fluid p-formgrid p-grid btn-control">
                                <div *ngIf="detailTask?.access_modifiers == 1" class="center not-public">
                                  <i class="pi pi-lock"></i>
                                  <span>非公開</span>
                                </div>

                                <div class="center public" *ngIf="detailTask?.access_modifiers == 0">
                                  <span>公開中</span>
                                </div>

                                <div class="func-btn"></div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div> -->
                    </div>
                  </div>
                </div>
              </p-card>
            </div>


            <div class="p-col-12">
              <div class="support-separate-no-border"></div>
            </div>

            <div class="p-col-12">
              <span class="p-text-bold">団体情報</span>
            </div>

            <div class="p-col-12">
              <div class="support-separate"></div>
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-first">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">団体区分詳細</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.class_sub_id }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-third">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">団体名</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.organization_name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-second">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview no-wrap">所在地(市区町村)
                      </span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.municipalities }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-fourth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview no-wrap">所在地<br>&nbsp;(それ以降の住所)</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.address_building }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-overview">電話番号</span>
                    </div>
                    <div class="p-col-9 description-title-overview">
                      <span>
                        {{ detailTask?.tel }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12">
              <div class="support-table-detail">
                <div class="support-line-sixth">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-col-3 large-title">
                      <span class="title-sub">※各団体へのお問い合わせは、急ぎの場合を除き、原則、本システム内のチャットでお願いします。</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
              <span class="p-text-bold seperate">希望内容</span>
            </div>

            <div class="p-col-12">
              <div class="support-separate"></div>
            </div>

            <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施教科等</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_subject }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-sixth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-sub">&nbsp;（学校における活動の位置づけ）</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">参加生徒の学年</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.target_grade }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">参加生徒人数</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_people_number }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div class="p-col-12">
              <hr class="sperate-between-line" />
            </div>

            <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">希望時期・日数</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_datetime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施場所</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_location }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施可能曜日</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_dayweek }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施希望時間</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_time }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">希望の詳細</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_content }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">その他、補足事項</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.remark }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">担当者氏名</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.manager_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <div class="p-col-12">
              <div class="sperate-between-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>